/**
 * Created by zhaoyan on 2017/11/20.
 *
 * 调用需要传参数：isShow是否显示下拉框
 * new CellCalendarComponent({isShow:false});
 */
import {CellBaseComponent} from '../base';
import template from './cell.calendar.html';
import './cell.calendar.scss'
import smallCalendar from './calendar.small/calendar.small'
import {CalendarTimeService, CalendarToolService, CalendarHandleDataService} from '../../../../../../../services/calendar/calendar.tool.service';
import {AutoSelect} from '../../../../../../util/autoSelect/autoSelect';
import {CalendarService} from "../../../../../../../services/calendar/calendar.service";
import CalendarRemind from "./calendar.remind.list/calendar.remind.list"
import Mediator from "../../../../../../../lib/mediator";
import {CalendarWorkflowData} from "../../../../../../calendar/calendar.main/calendar.workflow/calendar.workflow";
import {PMAPI} from "../../../../../../../lib/postmsg";
import {dgcService} from "../../../../../../../services/dataGrid/data-table-control.service";

let config = {
    template: template,
    data: {
        id: 'calendar',
        cellChart: {},
        dayList:[],
        smallCalendarCon:null,
        cancel_fields:[],
        headList: [ '日','一', '二', '三', '四', '五', '六' ],
        flag:true,
        allData:{}, //点击日期传过来的数据
        WorkflowData:{} //获取到的工作流数据
    },
    binds:[
        {
            event:'click',
            selector:'.pre-date-small',
            callback:function(context,event){
                this.actions.changeMonth('l');
            }
        },
        {
            event:'click',
            selector:'.next-date-small',
            callback:function(context,event){
                this.actions.changeMonth('r');
            }
        },
        {
            event:'click',
            selector:'.search-calendar',
            callback:function(context,event){
                event.stopPropagation();
                this.el.find('.high-search-group').toggle()
            }
        },
        {
            event:'click',
            selector:'.high-search li',
            callback:function(context,event){
                this.actions.goSearch($(context).attr('data-id'))
            }
        },
        //点击展示和收起日历提醒组件
        {
            event:'click',
            selector:'.calendar-folding',
            callback:function(context,event){
                // this.actions.goSearch($(context).attr('data-id'))
                let flag = this.data.flag;
                if (flag) {
                    this.el.find('.calendar-remind-comment').fadeOut();
                    this.data.flag = false;
                }else {
                    this.el.find('.calendar-remind-comment').fadeIn();
                    this.data.flag = true;
                }
               
            }
        },
    ],
    actions: {
        /**
         * 获取日历表
         * @param y
         * @param m
         */
        getCalendarDay(y,m){
            this.data.dayList = CalendarHandleDataService.createMonthCalendar(y,m,this.data.todayStr)
            m = parseInt(m)+1;
            this.data.selectedDateShow = y +'年'+ m +'月';
            $('.nowDate').html(this.data.selectedDateShow);
            this.actions.getMonthData();
        },
        /**
         * 获取当前月数据
         */
        getMonthData:function () {
            this.data.from_date = this.data.dayList[0]['weekList'][0]['dataTime'];
            this.data.to_date = this.data.dayList[5]['weekList'][6]['dataTime'];
            let data = {
                from_date: this.data.from_date ,
                to_date: this.data.to_date,
                cancel_fields: JSON.stringify([])
            }
            // console.log(new CalendarWorkflowData.getWorkflowDataTogether(),'this.data.WorkflowData')
            let _this = this;
            CalendarService.getCalendarData(data).then( res=> {
                _this.data.allData = res['date2csids'];
                for( let week of _this.data.dayList ){
                    for( let day of week['weekList'] ){
                        _this.actions.getIsHaveRemind(day,_this);
                    }
                }
                if(this.data.smallCalendarCon){
                    this.data.smallCalendarCon.destroySelf()
                }
                _this.data.smallCalendarCon = new smallCalendar({data:{dayList:this.data.dayList,headList:this.data.headList,dayShow:this.data.selectedDateShow}});
                _this.append(this.data.smallCalendarCon, this.el.find('.calendar-small'));
            })
        },
        /**
         * 获取日历棋盘是否有提醒条目
         */
        getIsHaveRemind(day,_this){
            let IsHaveRemind = false;
            for( let date in _this.data.allData ){
                if( date.indexOf( day['dataTime'] ) !== -1 ){
                    IsHaveRemind = true
                }
            }
            day['isHaveRemind'] = IsHaveRemind;
        },
        /**
         * 每天的提醒数据
         * @param day
         */
        getDayData: function (day,_this) {
            //获取当日包含的设置
            let calendarDate = [];
            let sum = 0;
            for( let date in _this.data.date2settings ){
                if( date.indexOf( day['dataTime'] ) !== -1 ){
                    for( let d of _this.data.date2settings[date] ){
                        let i = 0;
                        for( let c of calendarDate ){
                            if( c.id === d ){
                                i++;
                                c.count += 1;
                            }
                        }
                        if( i === 0 ){
                            calendarDate.push( { id:d,date:day.dataTime,count: 1 } );
                        }
                        sum += 1
                    }
                }
            }
            day['data'] = [];
            for( let set of calendarDate ){
                let setDetail = _this.data.calendarSettings[set.id];
                let count = 0;
                for( let select of setDetail['selectedRepresents_data'] ){
                    count += 1;
                    if( select[setDetail['field_id']].indexOf(day.dataTime) === -1 ){
                        continue;
                    }
                    let arrData = {};
                    if( setDetail.type === 0 ){
                        arrData['tableId'] = setDetail.table_id;
                        arrData['time'] = set.date;
                        arrData['setId'] = set.id;
                        arrData['dfield'] = setDetail.dfield;
                        arrData['color'] = CalendarToolService.handleColorRGB( setDetail.color , 1 );
                        arrData['isDrag'] = setDetail.is_drag;
                        arrData['real_id'] = JSON.stringify( [select._id] );
                        arrData['tableName'] = _this.data.tableid2name[setDetail.table_id];
                        arrData['fieldId'] = setDetail.field_id;
                        arrData['fieldValue'] = select[setDetail.field_id] || '';
                        arrData['fieldName'] = _this.data.fieldInfos[setDetail.field_id]['dname'];
                        arrData['type'] = 1;
                        arrData['isShow'] = _this.data.searchText === '' ? true : false;
                        arrData['selectedRepresents'] = setDetail['selectedRepresents'][0] || '';
                        arrData['selectedOpts'] = setDetail['selectedOpts'];
                        let selectFieldId = '';
                        if( setDetail['selectedEnums']&&setDetail['selectedEnums'][0]&&setDetail['selectedEnums'][0]!=='' ){
                            selectFieldId = setDetail['selectedEnums'][0];
                            arrData['selectOption'] = [];
                            arrData['selectOption'] = setDetail['selectedEnums_options'][selectFieldId] || [];
                            arrData['selectFieldId'] = selectFieldId;
                            arrData['selectField'] = _this.data.fieldInfos[selectFieldId]?_this.data.fieldInfos[selectFieldId].dfield : '';
                            arrData['selectFieldName'] = _this.data.fieldInfos[selectFieldId]?_this.data.fieldInfos[selectFieldId].dname : '';
                            arrData['isSetSelect'] = true;
                        }else {
                            arrData['isSetSelect'] = false;
                        }
                        //循环里面每一个小的数据
                        let data3show = [];
                        let everyData_3 = [];
                        for( let key in select ){
                            if( key === '_id' || ( !_this.data.fieldInfos[key] ) ){
                                continue;
                            }
                            everyData_3.push( {
                                fieldId: key,
                                _id: select['_id'],
                                fieldName: _this.data.fieldInfos[key]['dname'] || '',
                                fieldValue: select[key] || '',
                            } );
                            if( selectFieldId !== '' ){
                                everyData_3[0]['selectValue'] = '';
                                for( let s of setDetail['selectedEnums_data'] ){
                                    if( s._id === select['_id'] ){
                                        let selectLabel = s[selectFieldId];
                                        for( let o of arrData['selectOption'] ){
                                            if( o.label === selectLabel ){
                                                everyData_3[0]['selectValue'] = o.value;
                                                everyData_3[0]['selectLabel'] = selectLabel;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        for( let d of everyData_3 ){
                            if( !arrData['isShow'] && _this.data.searchText !== '' && ( d.fieldName.indexOf( _this.data.searchText ) !== -1 || d.fieldValue.toString().indexOf( _this.data.searchText ) !== -1 ) ){
                                arrData['isShow'] = true;
                                break;
                            }
                        }
                        data3show.push( everyData_3 );
                        arrData['data3show'] = data3show;
                        day['data'].push( arrData );
                    }
                }
            }
            day['dateLength'] = day['data'].length || 0;
        },
        /**
         * 创建日历提醒组件
         * @param _this
         */
        creatRemindList:function (_this) {
            if(_this.data.CalendarRemind){
                _this.data.CalendarRemind.destroySelf()
            }
            _this.data.CalendarRemind = new CalendarRemind({data:{remindList:_this.data.chooseData,fontSize:_this.data.remindFont}});
            // _this.actions.getDayDataCount(_this)
            _this.append(_this.data.CalendarRemind, _this.el.find('.calendar-remind-list'));
        },
        /**
         * 组装日数据
         */
        monthDataTogether: function (_this){
            let date = _this.data.chooseDate;
            _this.data.dayDataList = [];
            _this.actions.getDayData(_this.data.chooseData,_this);
            if(_this.data.chooseData.data){
                console.log('chooseData', _this.data.chooseData.data)
                _this.actions.creatRemindList(_this)
            }
        },
        /**
         * 改变月时间
         * @param lr
         */
        changeMonth: function (lr) {
            let y = this.data.selectData['y'];
            let m = this.data.selectData['m'];
            if( m > 0 && lr === 'l' ){
                this.data.selectData['m'] = m - 1;
            }
            if( m === 0 && lr === 'l' ){
                this.data.selectData['y'] = y - 1;
                this.data.selectData.m = 11;
            }
            if( m < 11 && lr === 'r' ){
                this.data.selectData['m'] = m + 1;
            }
            if( m === 11 && lr === 'r' ){
                this.data.selectData['y'] = y + 1;
                this.data.selectData['m'] = 0;
            }

            if(lr === 'l') {
                this.actions.getCalendarDay(this.data.selectData['y'], this.data.selectData['m']);
            } else if (lr === 'r') {
                this.actions.getCalendarDay(this.data.selectData['y'], this.data.selectData['m']);
            }
        },
        /**
         * 创建日历树下拉控件
         */
        createCalendarTree:function (_this) {
            let select_item_data = {
                'list': this.data.CalendarTreeSelect,
                choosed:[this.data.CalendarTreeSelect[0]],
                displayType: 'popup',
                multiSelect: false,
                onSelect: function (choosed) {
                    if(choosed.length > 0){
                        _this.data.CalendarTree.forEach(function (val,index) {
                            if(val.table_id === choosed[0].id){
                                _this.data.CalendarTableTreeSelect = val.items
                                _this.actions.createCalendarTableTree(_this);
                                _this.data.query_params = val.query_params;
                                _this.data.table_id = val.table_id
                            }
                        })
                    }else{
                        _this.data.CalendarTableTreeSelect = []
                        _this.actions.createCalendarTableTree(_this);
                    }
                    _this.actions.setHighSearch(_this);
                },
            };

            this.data.calendarTree = new AutoSelect({data:select_item_data});
            this.append(this.data.calendarTree, this.el.find('.calendarTree'));
        },
        /**
         * 设置高级查询
         */
        setHighSearch:function (_this) {
            _this.el.find('.high-search').empty()
            _this.el.find('.high-search').append('<li class="search-function-children" data-id="0">全部功能查询</li>')
            if(_this.data.query_params){
                _this.data.query_params.forEach(function (val) {
                    let html = '<li class="search-function-children" data-id="'+ val.id+'">'+val.name+'</li>';
                    _this.el.find('.high-search').append(html)
                })
            }
        },
        /**
         *常用功能查询
         * 参数：日历树ID,searchValue
         */
        goSearch: function (searchValue) {
            if(searchValue === 0){
                this.actions.changeChooseDate(this);
                return true
            }
            let table_id = this.data.table_id;
            let obj = {};
            for (let search of this.data.query_params) {
                if (searchValue === search.id.toString()) {
                    obj[table_id] = dgcService.translateAdvancedQuery(JSON.parse(search.queryParams));
                }
            }
            console.log(obj);
            this.actions.changeChooseDate(this,obj)
        },
        /**
         * 改变提醒数据
         */
        changeChooseDate:function (_this,obj) {
            let data = {
                from_date: _this.data.chooseDate,
                to_date: _this.data.chooseDate,
                // cancel_fields: JSON.stringify(_this.data.cancel_fields_now),
                tableid2filter:obj ? JSON.stringify(obj) : undefined,
            }
            
            CalendarService.getCalendarData(data).then( res=> {
                console.log('getCalendarData res', res)
                _this.data.date2settings = res['date2csids'];
                _this.data.calendarSettings = res['id2data'];
                _this.data.tableid2name = res['tableid2name'];
                _this.data.fieldInfos = res['field_infos'];
                CalendarService.saveFieldInfos(this.data.fieldInfos);
                _this.actions.monthDataTogether(_this)
            })
        },
        /**
         * 统计提醒条目
         */
        getDayDataCount:function (_this) {
            let length = 0;
            if(_this.data.chooseData.data){
                length = _this.data.chooseData.data.length;
            }
            _this.el.find('.remind-num').html(length)
        },
        /**
         * 创建日历树表下拉控件
         */
        createCalendarTableTree:function (temp) {
            let CalendarTableTreeSelect = [],choosed = [];
            let _this = temp
            this.data.CalendarTableTreeSelect.forEach(function (val) {
                CalendarTableTreeSelect.push({
                    id:val.field_id,
                    name:val.field_name,
                    setColor:val.color
                })
                choosed.push(val.field_id)
            })
            /**
             *附加显示字段下拉多选组件数据
             */
            let select_item_data = {
                'list': CalendarTableTreeSelect,
                isSetColor: true,
                displayType: 'popup',
                multiSelect: true,
                choosed:CalendarTableTreeSelect,
                onSelect: function (choosed) {
                    let cancel_fields = [];
                    if(choosed){
                        choosed.forEach(function (val) {
                            cancel_fields.push(val.id)
                        })
                    }
                    _this.data.cancel_fields_now = _.difference(_this.data.cancel_fields, cancel_fields);
                    _this.actions.changeChooseDate(_this)
                },
            };
            if(this.data.calendarTableTree){
                this.data.calendarTableTree.destroySelf()
            }
            this.data.calendarTableTree = new AutoSelect({data:select_item_data});
            this.append(this.data.calendarTableTree, this.el.find('.calendarTableTree'));
        },
        /**
         * 获取日历树
         */
        getCalendarTreeData:function () {
            CalendarService.getCalendarTreeData().then(res => {
                var dropDown = [];
                this.data.cancel_fields = [];
                let _this = this;
                if(res.code === 200){
                    this.data.CalendarTree = res.rows;
                    res.rows.forEach(function (val,index) {
                        dropDown.push({
                            id:val.table_id,
                            name:val.table_name
                        });
                        val.items.forEach(function (item) {
                            _this.data.cancel_fields.push(item.field_id)
                        })
                    })
                }
                _this.data.cancel_fields_now = _this.data.cancel_fields;
                this.data.CalendarTreeSelect = dropDown;
                this.actions.createCalendarTree(this)
            })
        }
    },
    beforeRender(){
        this.data.id += this.componentId;
    },
    afterRender() {
        let year = CalendarTimeService.getYear(),
            month = CalendarTimeService.getMonth(),
            day = CalendarTimeService.getDay(),
            _this = this;
        if(this.data.chart&&this.data.chart.customTextStyle.chartSize){
            this.data.remindFont = this.data.chart.customTextStyle.chartSize;
        }else {
            this.data.remindFont = '12'
        }
        this.data.todayStr = CalendarTimeService.formatDate(year, month, day);
        this.data.today = Object.assign({}, {'y': year, 'm':month, 'd':day});
        this.data.selectData = this.data.today;
        this.data.chooseDate = CalendarTimeService.formatDate(year, month, day);
        this.actions.getCalendarDay(year, month);
        this.actions.getCalendarTreeData();
        if (this.data.dayList.length!=0){
            this.data.dayList.forEach(function (val) {
                val.weekList.forEach(function (dayData) {
                    if(dayData.isToday){
                        _this.data.chooseData = dayData
                    }
                })
            })
        }

     
        Mediator.on('CalendarSmall: changeData',(data,time) => {        
            console.log(data,time,'data')  
            this.data.allData = data;
            this.data.chooseDate = data.data.dataTime;
            this.data.chooseData = data.data;
            // this.data.chooseData = mixData;
            this.actions.changeChooseDate(this);
            if (data.data.isToday) {
                this.el.find('.calendar-time').html('今天');
            }else {
                this.el.find('.calendar-time').html(data.data.dataTime);
            }
        });
       
        $(document).click(function(){
            if(_this.el){
                if(_this.el.find('.high-search-group')){
                    _this.el.find('.high-search-group').hide()
                }
            }
        });
        
        //中信日历隐藏时间和

        // !this.data.isShow&&this.el.find('.calendar-remind').hide()
    },
    firstAfterRender() {}
};

export let CellCalendarComponents = CellBaseComponent.extend(config);

// export class CellCalendarComponent extends CellBaseComponent {
//     constructor(data,event,extendConfig) {
//         super($.extend(true,{},config,extendConfig),data,event);
//         this.data.id += this.componentId;
//     }
// }



// WEBPACK FOOTER //
// app/components/bisystem/canvas/main/cells/cell/calendar/cell.calendar.js